import { IconCheckMarkCircle } from '../../icon/IconCheckMarkCircle';
import { IconProfile } from '../../icon/IconProfile';
import { IconRoundArrowRight } from '../../icon/IconRoundArrowRight';
import { IconSettings } from '../../icon/IconSettings';

export const NALOG_SITE_URL = 'https://lknpd.nalog.ru/auth/register';

export const APPROVAL_STEPS = [
    {
        icon: IconProfile,
        text: 'Зайдите на lknpd.nalog.ru или в приложение «Мой налог»',
    },
    {
        icon: IconSettings,
        text: 'Зайдите в «Настройки» — «Партнёры»',
    },
    {
        icon: IconCheckMarkCircle,
        text: 'Подтвердите запрос ООО «Яндекс»',
    },
    {
        icon: IconRoundArrowRight,
        text: 'Вернитесь сюда и нажмите «Далее»',
    },
];
